<template>
  <router-view></router-view>
  <!-- <HUBLoader v-if="pageLoading" /> -->
</template>

<script>
// import HUBLoader from '@/components/common/hubLoading.vue';

export default {
  // components: {
  //   HUBLoader,
  // },
};
</script>

<style scoped>
@import url('@/assets/styles/main.css');
</style>
